import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getAbsoluteFill, getFlexCenter } from "../../styles";
import LoadingSpinner from "../LoadingSpinner";

const Wrapper = styled.div<{ $isVisible: boolean; $instant: boolean }>`
  ${getAbsoluteFill};
  ${getFlexCenter};
  opacity: ${({ $isVisible, $instant }) => ($isVisible || $instant ? 1 : 0)};
  transition: opacity 150ms linear;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    position: relative;
    padding: 64px;
  }
`;

interface IProps {
  instant?: boolean;
  delay?: number;
  className?: string;
}

const PageLoader = ({ delay = 500, instant = false, className }: IProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // show spinner only if page is loading slowly to avoid flickering on instant load
    const timeoutId = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [delay]);

  return (
    <Wrapper $isVisible={isVisible} $instant={instant} className={className}>
      <LoadingSpinner />
    </Wrapper>
  );
};

export default PageLoader;
